import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = params.get("code");
    const errParam = params.get("error");
    const stateRaw = params.get("state") || "";
    if (errParam) {
      navigate(`/login?err=${encodeURIComponent(errParam)}`, { replace: true });
      return;
    }
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    // Decode signup intent from OAuth state param (survives localStorage clears)
    let stateRole = "";
    let stateInvite = "";
    try {
      const padded = stateRaw + "==".slice(0, (4 - stateRaw.length % 4) % 4);
      const decoded = JSON.parse(atob(padded));
      if (decoded && decoded.mode === "register") {
        stateRole = decoded.role || "";
        stateInvite = decoded.invite_code || "";
      }
    } catch (_e) { /* not a JSON state — fall back to localStorage */ }

    const role = stateRole || localStorage.getItem("pending_role") || "candidate";
    const invite = stateInvite || localStorage.getItem("pending_invite") || "";
    localStorage.removeItem("pending_role");
    localStorage.removeItem("pending_invite");

    const redirectUri = window.location.origin + "/auth/google";
    api.post("/auth/google/exchange", { code, role, invite_code: invite, redirect_uri: redirectUri })
      .then((r) => {
        setUser(r.data);
        const dest = r.data.role === "candidate" ? "/candidate"
          : r.data.role === "owner" ? "/admin"
          : r.data.role === "moderator" ? "/admin"
          : "/recruiter";
        navigate(dest, { replace: true });
      })
      .catch((e) => {
        const msg = e.response?.data?.detail || e.message || "Sign-in failed";
        setError(typeof msg === "string" ? msg : "Sign-in failed");
      });
  }, [params, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <div className="label-eyebrow text-[var(--brand-primary)]">Sign-in failed</div>
          <p className="mt-3 text-base">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })} className="btn-terra mt-6">Back to sign in</button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center font-display text-2xl">
      Signing you in…
    </div>
  );
}
